<template>
  <v-menu
    :disabled="$store.state.isViewOnlyEnabled"
    content-class="workflows-list-menu"
    location="bottom"
    close-delay="500"
  >
    <template v-slot:activator="{ props }">
      <div style="max-height: 48px;" class="d-flex align-center text-truncate">
        <v-icon class="mx-1" style="padding-bottom: 2px;" size="small">mds:arrow-forward-ios</v-icon>
        <v-tooltip location="bottom" open-delay="100">
          <template v-slot:activator="{ on, props: tooltipProps }">
            <div v-bind="tooltipProps" class="d-flex align-center"
                 style="cursor: text;">
              <v-icon class="mr-1" size="small" style="padding-bottom: 2px;">mds:account-tree</v-icon>
              <quick-rename-input
                class="workflow-quick-rename"
                :value="workflow.name"
                :disabled="$store.state.isWorkflowDisabled"
                @click="resetSelectedEvent"
                @onChange="renameWorkflow($event)"
                :max-length='40'
              />
            </div>
            <v-icon
              v-bind="props"
              v-on="{ ...on }"
              size="small"
              class="ml-1 hover-effect"
              style="cursor: pointer; padding-bottom: 2px;"
            >
              mds:keyboard-arrow-down
            </v-icon>
          </template>
          <span v-if="$store.state.isUserLoggedIn">
            Rename workflow
          </span>
          <span v-else>
            Workflow name
          </span>
        </v-tooltip>
      </div>
    </template>

    <v-list v-if="$store.state.isUserLoggedIn">
      <template v-for="(item, index) in workflows" :key="index">
        <v-list-item
          :active="$route.params.id == item.id"
          @click="onSelectWorkflow(item)"
        >
          <v-list-item-title
            class="text-body-1"
            :class="{ 'font-weight-bold': $route.params.projectId == item.id }"
          >
            <v-icon size="small" class="mr-2">mds:account-tree</v-icon>
            {{ item.name }}
            <v-icon v-if="$route.params.id == item.id">
              <v-icon size="x-small" color="black">mdi-check</v-icon>
            </v-icon>
          </v-list-item-title>
        </v-list-item>
      </template>
      <workflow-dialog ref="dialogWorkflow" v-if="subscriptionAccessType === 'FULL'">
        <template #activator="{ props }">
          <v-list-item v-bind="props">
            <v-list-item-title class="d-flex flex-row">
              <v-icon size="small" class="mr-2 pt-1">mds:add</v-icon>
              New workflow
            </v-list-item-title>
          </v-list-item>
        </template>
      </workflow-dialog>
    </v-list>
  </v-menu>
</template>

<script>
import workflowApi from '@/api/workflowApi'
import WorkflowDialog from '@/components/WorkflowDialog'
import QuickRenameInput from '@/components/QuickRenameInput.vue'
import { diagramHelpers } from '@/mixins/diagramHelpers'
import { EventBus } from '@/event-bus/event-bus'
import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    WorkflowDialog,
    QuickRenameInput
  },
  mixins: [diagramHelpers],
  computed: {
    ...mapGetters({
      project: 'projectMemberships/activeProject'
    }),
    ...mapState({
      workflows: state => state.workflows.workflows,
      workflow: state => state.workflow.workflow,
      subscriptionAccessType: state => state.payments.subscriptionAccessType
    })
  },
  methods: {
    async renameWorkflow (event) {
      let newName = event.target.innerText
      newName = (newName || '').trim()
      if (newName.length === 0 || newName === this.workflow.name) {
        return this.restoreValue(event)
      }

      if (newName.length > 40) {
        alert('A workflow name must be max 40 characters')
        return this.restoreValue(event)
      }

      const index = this.workflows.findIndex(ws => (ws.name === newName))
      if (index >= 0) {
        alert('A workflow with this name already exists.')
        return this.restoreValue(event)
      }

      await workflowApi.updateWorkflowName({
        ...this.workflow,
        name: newName,
        updateNote: {
          action: 'changed workflow name to',
          target: newName
        }
      })
    },
    resetSelectedEvent () {
      this.changeSelectedEvent(null)
    },
    restoreValue (ev) {
      if (ev.target.isContentEditable) {
        ev.target.textContent = this.workflow.name
        ev.target._ignoreBlur = true
        ev.target.blur()
      }
    },
    onSelectWorkflow (workflow) {
      this.$router.push({
        path: '/workflow/' + workflow.projectId + '/' + workflow.id
      }).then(() => {
        EventBus.$emit('get-workflow', workflow.id)
      }).catch(() => {
      })
    }
  }
}
</script>

<style>
.workflows-list-menu {
  max-height: calc(100vh - 20px);
}
</style>

<style scoped>
.workflow-quick-rename {
  max-width: 240px;
}

.hover-effect {
  transition: transform 200ms;
}

.hover-effect:hover {
  transform: translate(0, 4px);
}
</style>
